export default "__VITE_ASSET__BD5U2jDg__"